// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__19HQJ","tab-item":"Tab_tab-item__296Cx","is-active":"Tab_is-active__60yb-"};